import React from "react"
import styles from "../../css/gallery.module.css"

const Service = ({ picture }) => {
  const { pic } = picture
  return <img src={pic} className={styles.pic} alt="single tour" />
}

export default Service
